import posthog from 'posthog-js';
import type { User } from 'services/types/user';

export const identifyPosthogUser = (user: User) => {
  try {
    if (import.meta.env.NODE_ENV !== 'test') {
      posthog.identify(user.email, {
        email: user.email,
        isTestUser: user.isTestUser,
        isAdmin: user.isAdmin,
        businessUnitIds: user.businessUnitIds,
        userRole: user.role,
      });

      if (user.businessUnitIds && user.businessUnitIds.length > 0) {
        user.businessUnitIds.forEach((businessUnitId) => {
          posthog.group(
            'business_unit',
            `${import.meta.env.NODE_ENV === 'development' ? 'dev_' : ''}${businessUnitId}`,
            {
              businessUnitId,
            }
          );
        });
      }

      posthog.alias(user.id.toString(), user.email);
    }
  } catch (error) {
    console.error(error);
  }
};

export const posthogReset = () => {
  try {
    if (import.meta.env.NODE_ENV !== 'test') {
      posthog.reset();
    }
  } catch (error) {
    console.error(error);
  }
};

export const capturePageView = () => {
  if (import.meta.env.NODE_ENV !== 'test') {
    posthog.capture('$pageview');
  }
};
